export enum TermsAcceptanceFilterNames {
  EMPLOYEE_NAME = "employeeName",
  BENEFIT_PLAN_NAME = "benefitPlanName",
  BENEFIT_PLAN_TYPE = "benefitPlanType",
}
